import React from 'react';
import DataManagementDictionaryCardItem from './DataManagementDictionaryCardItem';

const DataManagementDictionaryCardItems = ({ category, code, dictionaries }) => (
  dictionaries.map((dictionary, index) => (
    <DataManagementDictionaryCardItem
      category={category}
      code={code}
      key={`aridhia_data_management_card_item_${dictionary.id}`}
      dictionaryCode={dictionary.code}
      role={dictionary}
      upward={index > 4}
    />
  ))
);

export default DataManagementDictionaryCardItems;
